import { render, staticRenderFns } from "./ChatBox.vue?vue&type=template&id=6069a5de&scoped=true"
import script from "./ChatBox.vue?vue&type=script&lang=js"
export * from "./ChatBox.vue?vue&type=script&lang=js"
import style0 from "./ChatBox.vue?vue&type=style&index=0&id=6069a5de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6069a5de",
  null
  
)

export default component.exports